<script>
import appConfig from "@/app.config"
import Swal from 'sweetalert2'
import { http } from '@/helpers/easyindustriaapi/config'
import Layout from "@/views/layouts/main"
import PageHeader from "@/components/page-header"
import SpecialtyController from '@/controller/SpecialtyController'
import List from "./list"
import Insert from "./insert"
import Edit from "./edit"

export default {
  page: {
    title: 'Tratamentos',
    meta: [ {name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, List, Insert, Edit },
  data() {
    return {
      currentSpecialty: {},
      specialty: [],
      listCodeTax: [],
      inserindo: false,
      editando: false,
      titleBody: 'Tratamento',
      items: [
        {
        text: "Dashboard",
        href: "/",
        },
        {
        text: "Parâmetros",
        href: "/",
        active: true,
        },
        {
        text: "Tratamento",
        href: "/parametros/tratamento",
        active: true,
        }
      ],
    }
  },
  computed: {
    isHide() {
      return (!this.inserindo && !this.editando);
    },
    axiosParams() {
      const params = new URLSearchParams();
      params.append("empresa_id", this.currentEmpresa.id);

      return params;
    }
  },
  created() {
    this.currentUser    = JSON.parse(localStorage.getItem('user'))
    this.currentEmpresa = JSON.parse(localStorage.getItem('currentEmpresa'))
    this.specialtyController = new SpecialtyController()
  },
  mounted() {
    Swal.fire({
      title: "Aguarde...",
      text: "Carregando dados.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(); // Exibe o loader enquanto a requisição está em andamento
      },
    })
    this.getData()
  },
  methods: {
    makeToast(variant = null, message = 'Error generic') {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: 'b-toaster-bottom-right',
        variant: variant,
        solid: true,
        appendToast: true
      });
    },
    changeHomeTitle(newTitle) {
      this.titleBody = newTitle;
    },
    back() {
      this.inserindo = false;
      this.editando = false;
    },
    onLoader() {
      if (document.getElementById("preloader").style.display === "none")
      {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";
      }
    },
    offLoader() {
      if (document.getElementById("preloader").style.display === "block")
      {
        setTimeout(function () {
          document.getElementById("preloader").style.display = "none";
          document.getElementById("status").style.display = "none";
        }, 2500);
      }
    },

    async getData() {
      let tables = await this.specialtyController.getSpecialties(this.axiosParams)
      this.specialty = tables.specialtys
      this.listCodeTax = tables.codeTaxs
      Swal.close()
    },

    insert () {
      this.inserindo = !this.inserindo;
    },
    edit(value) {
      this.currentSpecialty = value;
      this.editando = !this.editando;
    },
    async doPost(Specialty) {
      Specialty.empresa_id = this.currentEmpresa.id;
      let response = await http.post('/specialty?empresa_id='+this.currentEmpresa.id, Specialty)
        .catch((error) => {
            this.makeToast('danger', error.response);
            this.offLoader();
        });

      if (response.status === 200) {
        this.getData();
        this.back();
        this.makeToast('success', 'Registro incluído');
      }
    },
    async doPut(Specialty) {
      console.log(Specialty)
      this.onLoader()
      Specialty.user_id = this.currentUser.id
      const promise = http.put(`/specialty/${Specialty.id}?empresa_id=${this.currentEmpresa.id}`, Specialty)
      promise.then((response) => {
        console.log(response)
        this.getData()
        this.back()
        this.makeToast('success', 'Registro alterado')
        this.offLoader()
      })      
      .catch((error) => {
        console.log(error.response)
        this.offLoader()
        if (error.response.status && error.response.status === 500) {
          this.makeToast('danger', error.response.data.message)
        } else {
          this.makeToast('danger', error.response)
        }
      }).finally(() => {
        this.offLoader()
      });
    },
    async doDelete(Specialty) {
      this.onLoader()
      Specialty.empresa_id = this.currentEmpresa.id
      const promisse = http.delete('/specialty/'+Specialty.id+'?empresa_id='+this.currentEmpresa.id, Specialty)
      promisse
      .then((response) => {
        console.log(response)
        this.getData()
        this.back()
        this.makeToast('warning', 'Registro excluído')
      })
      .catch((error) => {
        this.offLoader()
        this.makeToast('danger', error.response)
      }).finally(() => {
        this.offLoader()
      })
    },
  },
}
</script>

<template>
<Layout>
  <PageHeader :title="titleBody" :items="items" />
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <!-- Start Bar Buttons -->
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12 col-md-6"></div>
            <div class="col-sm-12 col-md-6 text-md-right">
              <button @click="insert()" v-if="isHide" type="button" class="btn btn-success">+ Incluir Tratamento</button>
              <button @click="back()" v-if="!isHide" class="btn btn-secondary">Voltar</button>
            </div>
          </div>
        </div>
        <!-- End Bar Buttons -->
        <div class="card-body" v-if="!isHide">
          <Insert
           v-if="inserindo"
           :currentEmpresa="currentEmpresa"
           :listCodeTax="listCodeTax"
           @newTitle="changeHomeTitle"
           @doPost="doPost "
          />
          <Edit
           v-if="editando"
           :currentEmpresa="currentEmpresa"
           :oldSpecialty="currentSpecialty"
           :listCodeTax="listCodeTax"
           @newTitle="changeHomeTitle"
           @doPut="doPut"
          />
        </div>
        <List v-if="isHide"
         :currentEmpresa="currentEmpresa"
         :listSpecialty="specialty"
         :hide="isHide"
         @newTitle="changeHomeTitle"
         @edit="edit"
         @doDelete="doDelete"
        />
      </div>
    </div>
  </div>
</Layout>
</template>